/**
 * Public answer-rating page (`/avaliar#<token>`, and `/avaliar/<token>` for links already
 * sent; alias `/rate`). Reached from the stars at the bottom of a Smith answer e-mail; works
 * without signing in. How long a link lasts is the deployment's to set, so the copy never
 * names a number of days: the dates come from the token itself.
 */

export const feedback = {
  pageTitle: 'Rate this answer',
  subtitle: 'Your rating helps us improve the answers you receive.',
  ratingFor: 'You are rating',
  answeredAt: (date: string) => `Answered ${date}`,
  responseTime: 'Response time',
  responseTimeHint: 'How quickly did the answer arrive?',
  assertiveness: 'Accuracy',
  assertivenessHint: 'How right and useful was the answer?',
  scoreLabel: (n: number) => `${n} of 5`,
  scoreLow: 'Poor',
  scoreHigh: 'Excellent',
  suggestions: 'Suggestions and improvements',
  suggestionsPlaceholder: 'What would have made this answer better?',
  charsLeft: (n: number) => `${n} characters left`,
  submit: 'Send rating',
  update: 'Update rating',
  sending: 'Sending…',
  nothingToSend: 'Choose a rating or write a suggestion.',
  /** The reader emptied the only thing they had sent, which fr-docs cannot store as a rating. */
  clearNeedsRating: 'To remove your suggestion, keep at least one rating.',
  thanksTitle: 'Thank you!',
  thanksBody: 'Your rating was recorded. You can change it while this link is valid.',
  thanksBodyUntil: (date: string) => `Your rating was recorded. You can change it until ${date}.`,
  edit: 'Change my rating',
  previousSubmission: (count: number) =>
    count === 1 ? 'You already rated this answer once.' : `You already rated this answer ${count} times.`,
  invalidTitle: 'This link is not valid',
  invalidBody: 'The rating link is invalid or has expired.',
  expiredOn: (date: string) => `This rating link expired on ${date}.`,
  /** The run page's rating card, when the answer's link has expired or is not valid. */
  inlineClosed: 'This answer can no longer be rated.',
  inlineClosedOn: (date: string) => `Rating this answer closed on ${date}.`
}
